<template>
    <div class="login">
        <div class="primary" />
        <el-form :model="form" :rules="rules" class="form" ref="form" status-icon>
            <h1 class="title">巨幕</h1>
            <el-form-item prop="mobile">
                <el-input
                    autocomplete="off"
                    maxlength="11"
                    placeholder="请输入手机号"
                    v-model="form.mobile"
                />
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    autocomplete="off"
                    placeholder="请输入密码"
                    type="password"
                    v-model="form.password"
                />
            </el-form-item>
            <div style="text-align: right; margin-bottom: 10px;">
                <router-link :to="ROUTER_FORGET" style="font-size: 14px; color: #409eff;">忘记密码</router-link>
            </div>
            <el-button :loading="loading" @click="handleLogin" class="btn-login" type="primary">登录</el-button>
        </el-form>
    </div>
</template>

<script>
import { api, post } from '../../service';
import { ROUTER_FORGET, ROUTER_INDEX } from '../../router.js';

export default {
    data() {
        return {
            ROUTER_FORGET,
            form: {
                mobile: '',
                password: '',
            },
            loading: false,
            rules: {
                mobile: [
                    {
                        message: '请输入手机号',
                        required: true,
                        pattern: /^\d{11}$/,
                        trigger: 'change',
                    },
                ],
                password: [
                    {
                        message: '请输入密码',
                        required: true,
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    methods: {
        handleLogin() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    post(api.user.login, this.form)
                        .then((data) => {
                            const { token } = data;
                            localStorage.setItem('token', token);
                            this.$router.push(ROUTER_INDEX);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.login {
    height: 100vh;
}
.primary {
    width: 100%;
    height: 50%;
    background-color: #2196f3;
    position: absolute;
    top: 0;
    left: 0;
}
.form {
    width: 460px;
    background-color: #ffffff;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
        0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    padding: 20px 50px 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.title {
    text-align: center;
    font-size: 42px;
    color: #2196f3;
    margin-bottom: 30px;
}
.btn-login {
    width: 100%;
}
</style>
